<template>
  <div>
    <Request/>
  </div>
</template>

<script>
import Request from '../components/RequestAccess'
export default {
  components: {
    Request
  }
}
</script>

<style>

</style>